import React, { useRef, useState } from "react";
import {
  StyleSheet,
  Text,
  View,
  TouchableOpacity,
  Dimensions,
  SafeAreaView,
  Image,
  ImageBackground,
  TextInput,
  FlatList,
} from "react-native";
import { Octicons } from "@expo/vector-icons";
import { FontAwesome } from "@expo/vector-icons";
const { width, height } = Dimensions.get("window");
export default function teblrrole({ navigation, data }) {
  return (
    <View style={styles.back}>
      <View style={styles.head}>
        <View style={[styles.viewhead, { width: width * 0.45 }]}>
          <Text style={[styles.texthead, { marginLeft: 40 }]}>User</Text>
        </View>
        <View style={[styles.viewhead, { width: width * 0.228 }]}>
          <Text style={styles.texthead}>Role</Text>
        </View>
        <View style={[styles.viewhead, { width: width * 0.15 }]}>
          <Text style={styles.texthead}>Status</Text>
        </View>
      </View>
      <FlatList
        data={data}
        scrollEnabled={false}
        renderItem={({ index, item }) => {
          console.log(item.user_accounts);
          return (
            <View>
              <View style={[styles.viewmain, { backgroundColor: "#fff" }]}>
                <View
                  onPress={() => navigation.navigate("ProflieUser")}
                  style={[styles.viewdetail, { width: width * 0.45 }]}
                >
                  <Image
                    source={{
                      uri:
                        
                        item.user_accounts.image_Profile,
                    }}
                    style={styles.img}
                  />
                  <View>
                    {item.user_accounts.name != null ? (
                      <Text style={styles.textdeil}>
                        {item.user_accounts.name}
                      </Text>
                    ) : (
                      <Text style={styles.textdeil}>
                        {item.user_accounts.username}
                      </Text>
                    )}

                    <Text style={styles.textdetail}>
                      {item.user_accounts.email}
                    </Text>
                  </View>
                </View>
                <View style={[styles.viewdetail, { width: width * 0.228 }]}>
                  <Text style={styles.textdate}>{item.user_accounts.role}</Text>
                </View>
                <View style={[styles.viewdetail, { width: width * 0.15 }]}>
                  <Octicons
                    name="dot-fill"
                    size={16}
                    color="#2DCE98"
                    style={{ alignSelf: "center", marginRight: 10 }}
                  />
                  <Text style={styles.textdate}>Active</Text>
                </View>
              </View>
            </View>
          );
        }}
      />
      <View style={styles.viewatc}>
        <TouchableOpacity style={styles.touchatc}>
          <FontAwesome
            name="angle-left"
            size={15}
            color="#7764E4"
            style={{ alignSelf: "center" }}
          />
        </TouchableOpacity>
        <TouchableOpacity
          style={[styles.touchatc, { backgroundColor: "#FCC81D" }]}
        >
          <Text style={styles.textatc}>1</Text>
        </TouchableOpacity>
        <TouchableOpacity style={styles.touchatc}>
          <Text style={styles.textatc}>2</Text>
        </TouchableOpacity>
        <TouchableOpacity style={styles.touchatc}>
          <Text style={styles.textatc}>3</Text>
        </TouchableOpacity>
        <TouchableOpacity style={styles.touchatc}>
          <Text style={styles.textatc}>4</Text>
        </TouchableOpacity>
        <TouchableOpacity style={styles.touchatc}>
          <FontAwesome
            name="angle-right"
            size={15}
            color="#7764E4"
            style={{ alignSelf: "center" }}
          />
        </TouchableOpacity>
      </View>
    </View>
  );
}
const styles = StyleSheet.create({
  back: {
    width: width * 0.83,
    height: "80%",
    borderWidth: 0.05,
    borderColor: "#00000010",
    backgroundColor: "#fff",
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 3.84,
    elevation: 5,
    marginTop: 10,
  },
  head: {
    width: width * 0.828,
    flexDirection: "row",
    backgroundColor: "#F1F3F9",
  },
  viewhead: {
    paddingLeft: 10,
  },
  texthead: {
    fontFamily: "Prompt-Regular",
    fontSize: 18,
    color: "#172B4D",
  },
  viewdetail: {
    flexDirection: "row",
  },
  img: {
    width: 39,
    height: 39,
    marginTop: 5,
  },
  textdeil: {
    fontFamily: "Prompt-Regular",
    fontSize: 16,
    color: "#393939",
    marginTop: 5,
    marginLeft: 15,
  },
  textdetail: {
    fontFamily: "Prompt-Regular",
    fontSize: 12,
    color: "#393939",
    marginLeft: 15,
  },
  viewmain: {
    flexDirection: "row",
    width: width * 0.828,
    height: 50,
    paddingHorizontal: 5,
  },
  textdate: {
    fontFamily: "Prompt-Regular",
    fontSize: 16,
    color: "#172B4D",
    alignSelf: "center",
  },
  viewatc: {
    width: width * 0.18,
    height: 30,
    justifyContent: "space-between",
    alignSelf: "flex-end",
    marginBottom: 20,
    flexDirection: "row",
    marginRight: 20,
  },
  touchatc: {
    width: 30,
    height: 30,
    borderRadius: 15,
    borderWidth: 0.5,
    borderColor: "#8898AA",
    justifyContent: "center",
  },
  textatc: {
    fontFamily: "Prompt-Regular",
    fontSize: 15,
    color: "#7764E4",
    alignSelf: "center",
  },
});
